module.exports = __webpack_public_path__ + "assets/59ad22cfb954022ae91a8f79398fd385.png";